import { IInventoryPage } from '../../inventory-page.interface';


export const STORE_RESEARCH_PAGE: IInventoryPage = {
	'route': '/store/research',
	'title': 'Store Research',
	'uiReference': [
		'MOST POPULAR',
		'/mo',
		'Limited Free Version',
		'EVERYTHING'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/public/public-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/store/store-research/store-research.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/public/store/store-research/store-research.component.html'
	]
};
